<template>
    <div id="point">
        <div class="modal fade in" style="display: block;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <form @submit.prevent="sendAnswer()">
                        <div class="modal-header">
                            <!--
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            -->
                            <h3 class="modal-title">{{index+1}}.</h3>
                            <div v-html="point.question.text"></div>
                        </div>
                        <!-- Question media -->
                        <div v-if="point.question.media && point.question.media.length">
                            <div class="modal-body text-center" v-if="!mediaLoaded">
                            <i class="fa fa-spinner fa-spin"></i> {{ $t('common.loading_images') }}
                            </div>
                            <div class="modal-body" v-for="medium of point.question.media" :key="medium._id">
                                <img :id="'medium-'+medium._id" :src="medium.optimized || medium.url" class="img-fluid" v-if="!medium.error">
                            </div>
                        </div>
                        <div :class="'modal-body question-' + questionType"
                             v-if="questionType !== 'none'">
                            <!-- Single answer -->
                            <table class="table" v-if="questionType === 'single' || questionType === 'multiple'">
                                <tr v-for="(option, index) in point.question.answers" :key="index">
                                    <td :colspan="(questionType === 'multiple' || answer === index) ? 1 : 2"
                                        :class="{'text-success': answered && option.correct, 'text-danger': answered && !option.correct}">
                                        <label class="form-check-label">
                                            <input type="radio" class="form-check-input"
                                                   :disabled="answered || loading"
                                                   v-model="answer" v-if="questionType === 'single'"
                                                   :value="index" @change="updateSingleTypeAnswer">
                                            <input type="checkbox" class="form-check-input"
                                                   :disabled="answered || loading"
                                                   v-model="answer" v-if="questionType === 'multiple'"
                                                   :value="index" @change="updateMultipleTypeAnswer">
                                            <span class="form-check-label-text">{{option.text}}</span>
                                        </label>
                                    </td>
                                    <td class="answer-validity"
                                        v-if="answered && questionType === 'single' && answer === index">
                                        <span v-if="option.correct" class="pull-right text-success">
                                            <i class="fa fa-check"></i></span>
                                        <span v-if="!option.correct" class="pull-right text-danger">
                                            <i class="fa fa-remove"></i></span>
                                    </td>
                                    <td class="answer-validity" v-if="answered && questionType === 'multiple'">
                                        <span v-if="(answer.indexOf(index) !== -1) === option.correct"
                                              class="pull-right text-success">
                                            <i class="fa fa-check"></i>
                                        </span>
                                        <span v-if="(answer.indexOf(index) !== -1) !== option.correct"
                                              class="pull-right text-danger">
                                            <i class="fa fa-remove"></i>
                                        </span>
                                    </td>
                                </tr>
                            </table>
                            <!-- Text or number answer -->
                            <div v-if="questionType === 'text' || questionType === 'number'">
                                <input type="text" class="form-control" v-model="answer" v-if="!answered && questionType === 'text'">
                                <input type="text" class="form-control" v-model="answer" v-if="!answered && questionType === 'number'">
                                <div v-if="answered">
                                    <p class="text-success" v-if="answered.correct">
                                        {{answer}}
                                        <span class="pull-right"><i class="fa fa-check"></i></span>
                                    </p>
                                    <p class="text-danger" v-if="!answered.correct">
                                        {{answer}}
                                    <span class="pull-right"><i class="fa fa-remove"></i></span>
                                    </p>
                                    <p v-if="!answered.correct">
                                        <span class="text-muted">{{$t('point.correct_answer_is')}}</span><br>
                                        <span class="text-success">{{point.question.answers[0].text}}</span>
                                    </p>
                                </div>
                            </div>
                            <!-- Photo or video answer -->
                            <div v-if="questionType === 'photo' || questionType === 'video'">
                                <div class="alert alert-info" v-if="questionType === 'video'">
                                    {{$t('point.video_not_supported')}}
                                </div>
                                <!--
                                <p v-if="!userMediaSupported">
                                    Sadly we cannot access the camera directly on your device. You will
                                    have to continue without making a photo.
                                </p>
                                <div v-if="userMediaSupported">
                                    <img v-if="capturedMedia && !answered" class="img-fluid" id="media-preview">
                                    <div class="alert alert-success" v-if="answered">
                                        Thank you! You can now continue playing.
                                    </div>
                                    <button v-if="!capturedMedia && !answered" type="button" class="btn btn-link"
                                            @click="requestMedia('image')">
                                        <i class="fa fa-camera"></i> Take a photo
                                    </button>
                                </div>
                                -->
                                <img v-if="capturedMedia && !answered" class="img-fluid" id="media-preview">
                                <div class="alert alert-success" v-if="answered">
                                    {{$t('point.answered_feedback')}}
                                </div>
                                <div v-if="!capturedMedia && !answered">
                                    <input class="file-input" id="image-input" type="file" accept="image/*" capture @change="captureMedia($event)"/>
                                    <label for="image-input">
                                        <span class="btn btn-link">
                                            <i class="fa fa-camera"></i> {{$t('point.take_photo')}}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <span v-if="capturedMedia && !answered">
                                <input class="file-input" id="image-input-retake" type="file" accept="image/*" capture @change="captureMedia($event)"/>
                                <label for="image-input-retake">
                                    <span class="btn btn-secondary">
                                        <i class="fa fa-camera"></i> {{$t('point.take_new_photo')}}
                                    </span>
                                </label>
                            </span>
                            <button type="submit" class="btn btn-primary" v-if="!answered && !continueWithoutAnswering"
                                    :disabled="answerEmpty || loading">{{$t('point.send_answer')}}
                            </button>
                            <button type="submit" class="btn btn-primary" v-if="!answered && continueWithoutAnswering">
                                {{$t('common.continue')}}
                            </button>
                            <button type="button" class="btn btn-secondary" v-if="answered" @click="closePoint()">
                                {{$t('common.close')}}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal-backdrop fade in"></div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import {SET_ACTIVE_POINT_ANSWER} from '../store/mutation_types'

    export default {
        data() {
            const store = this.$store

            return {
                get answer() {
                    return store.state.points.activePointAnswer
                },
                set answer(value) {
                    store.dispatch('setAnswer', value)
                },
                mediaLoaded: false
            }
        },
        mounted() {
            let loaded = 0

            if (this.point.question.media && this.point.question.media.length) {
                this.point.question.media.forEach(medium => {
                    const img = document.getElementById('medium-'+medium._id)

                    img.addEventListener('load', () => {
                        if (++loaded === this.point.question.media.length) {
                            this.mediaLoaded = true
                        }
                    })

                    img.addEventListener('error', () => {
                        if (++loaded === this.point.question.media.length) {
                            this.mediaLoaded = true
                        }
                    })
                })
            }
        },
        computed: {
            ...mapState({
                game: state => state.events.activeEvent,
                team: state => state.teams.activeTeam,
                point: state => state.points.activePoint,
                index: state => state.events.activeEvent.points.indexOf(state.points.activePoint),
                questionType: state => state.points.activePoint.question.answerType,
                answered: state => state.points.activePointAnswered,
                loading: state => state.points.loading,
                capturedMedia: state => state.client.capturedMedia
            }),
            answerEmpty: function () {
                switch (this.questionType) {
                    default:
                        return !this.answer
                    case 'single':
                        return this.answer === null
                    case 'number':
                        return !this.answer || !this.answer.match(/^\s*([0-9]+)((\.|,)([0-9]+))?\s*$/)
                    case 'multiple':
                        return !this.answer.length
                    case 'none':
                        return false
                    case 'photo':
                    case 'video':
                        return !this.capturedMedia
                }
            },
            continueWithoutAnswering: function () {
                if (this.questionType === 'none') {
                    return true;
                }

                if ((this.questionType === 'photo' || this.questionType === 'video') && !this.userMediaSupported) {
                    return true;
                }

                return false;
            }
        },
        methods: {
            ...mapActions([
                'closePoint',
                'sendAnswer',
                'setCapturedMedia'
            ]),
            showOptionFeedback: function (index) {
                if (this.questionType === 'single') {
                    return this.answer === index;
                }

                return true;//this.answer.indexOf(index) !== -1;
            },
            exit() {
                this.$store.commit('EXIT_GAME');
            },
            updateSingleTypeAnswer(event) {
                this.$store.dispatch('setAnswer', event.target.value)
            },
            updateMultipleTypeAnswer(event) {
                const value = event.target.value

                if (this.answer.indexOf(value) === -1) {
                    this.$store.dispatch('setAnswer', this.answer.concat([value]))
                } else {
                    this.$store.dispatch('setAnswer', this.answer.filter(option => option !== value))
                }
            },
            captureMedia: function (e) {
                const file = e.target.files[0]

                if (!file) {
                    return
                }

                this.setCapturedMedia(file)
            }
        },
        watch: {
            capturedMedia: function (file) {
                if (!file) {
                    return
                }

                const reader = new FileReader()

                reader.readAsDataURL(file)

                reader.onload = function (e) {
                    document.getElementById('media-preview').src = e.target.result// window.URL.createObjectURL(this.capturedMedia)
                }
            }
        }
    }
</script>

<style>
    #point .modal-body.question-single, #point .modal-body.question-multiple {
        padding: 0;
    }

    #point .table {
        margin-bottom: 0;
    }

    #point .table tr:first-child td {
        border-top: 0;
    }

    #point .form-check-label-text {
        padding-left: 1px;
    }

    #point .answer-validity {
        white-space: nowrap;
        vertical-align: middle;
    }

    #point .file-input {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }
</style>


// WEBPACK FOOTER //
// point.vue?17c68e10